export const endpoints = {
    HOMEPAGE: '/',
    DETAILS: '/details/',
    CHECKOUT: '/checkout/',
    THANK: '/thank'
}